export default "__VITE_ASSET__CJu5y86c__"